import { makeAutoObservable } from 'mobx';
import { CandidateWithAge } from '~/definitions/candidate';

export default class CandidateStore {
    candidates: CandidateWithAge[] = [];

    isDisabledVote: boolean = false;
    isUserChild: boolean = false;
    isUserAlreadyVoted: boolean = false;

    isOpenVoteSummaryModal: boolean = false;
    isViewCandidateOnly: boolean = false;

    constructor() {
        this.resetToDefault();
        makeAutoObservable(this);
    }

    resetToDefault() {
        this.candidates = [];
        this.isOpenVoteSummaryModal = false;
        this.isDisabledVote = false;
        this.isViewCandidateOnly = false;
        this.isUserAlreadyVoted = false;
        this.isUserChild = false;
    }

    setCandidates = (data: CandidateWithAge[]): void => {
        this.candidates = data;
    };

    setIsDisabledVote = (value: boolean) => {
        this.isDisabledVote = value;
    };

    setIsOpenVoteSummaryModal = (value: boolean) => {
        this.isOpenVoteSummaryModal = value;
    };

    setIsViewCandidateOnly = (value: boolean) => {
        this.isViewCandidateOnly = value;
    };

    setIsUserAlreadyVoted = (value: boolean) => {
        this.isUserAlreadyVoted = value;
    };

    setIsUserChild = (value: boolean) => {
        this.isUserChild = value;
    };
}
